<template>
  <section class="user-box">
    <el-dialog title="修改个人信息" :visible.sync="force?true:myVisible" width="515px" :close-on-click-modal="false" :show-close="true" :class="force?'force':''">
      <el-form size="small" :model="handleForm" :hide-required-asterisk="true" status-icon :rules="userInfoFormRules" ref="handleForm" label-width="80px" >
        <el-form-item label="姓名:" prop="realName">
          <el-input type="text" placeholder="请输入姓名" v-model="handleForm.realName" maxlength="11"></el-input>
        </el-form-item>
        <el-form-item :label="isEditPhone&&isCheckMsgCode?'验证码:':'手机号码:'" prop="phone">
          <div v-if="!isEditPhone" class="phone">
            <span>{{handleForm.phone}}</span>
            <el-link type="primary" :underline="false" @click="editPhone">修改</el-link>
          </div>
          <div v-else class="msg-code">
            <el-input v-if="isCheckMsgCode" type="text" placeholder="请输入验证码" @input="checkSmsCode" v-model="handleForm.smsCode" maxlength="6">
            </el-input>
            <el-input v-else type="text" placeholder="请输入新手机号码" v-model="handleForm.phone" maxlength="11">
            </el-input>
            <el-button v-if="isCheckMsgCode" class="msg-btn" :disabled="countDown.startCount" :class="countDown.startCount && 'sended'" @click="getSmsCode">{{countDown.startCount ? countDown.count+'s后重试' :'发送验证码'}}</el-button>
          </div>
        </el-form-item>
        <el-form-item label="照片:" prop="headPortaitUrl">
          <image-upload :width="100" :height="100" :value="handleForm.headPortaitUrl" @change="handleAvatarSuccess"></image-upload>
        </el-form-item>
        <el-form-item label="昵称:" prop="nickName">
          <el-input type="text" placeholder="请输入昵称" v-model="handleForm.nickName" maxlength="20"></el-input>
        </el-form-item>
        <el-form-item label="性别:" prop="sex">
          <el-radio-group v-model="handleForm.sex">
            <el-radio :label="0">男</el-radio>
            <el-radio :label="1">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="updateUserInfo" :loading="logining">确定</el-button>
      </div>
    </el-dialog>
  </section>
</template>
<script>
import ImageUpload from '@/components/common/ImageUpload'
// import storage from '@/utils/storage'
// import RsaKey from '@/utils/rsa'
export default {
  name: 'editUserInfo',
  components: {
    ImageUpload
  },
  props: {
    userInfo: {
      required: false,
      type: Object,
      default: () => { return {} }
    },
    force: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    'myVisible': function (value) {
      if (!value) {
        this.$emit('close')
      }
    }
  },
  data () {
    var validatePhoneNo = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号'))
      } else if (!(/^1[123456789]\d{9}$/.test(value))) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    }
    return {
      logining: false,
      isCheckMsgCode: true,
      isEditPhone: false,
      myVisible: true,
      handleForm: {},
      countDown: {
        startCount: false,
        timer: {},
        defaultCount: 60,
        count: 60
      },
      oldPhone: '',
      userInfoFormRules: {
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: validatePhoneNo, message: '请输入正确的手机号码', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (this.oldPhone === value) {
                callback()
                return
              }
              const params = {
                phone: value
              }
              this.api.commonService.findUserIsExit(params).then(data => {
                if (data.errorMessage) {
                  this.$message.error('查询失败')
                } else {
                  if (data.body) {
                    callback(new Error('该手机号码已经被注册'))
                  } else {
                    callback()
                  }
                }
              })
            },
            trigger: 'blur'
          }
        ],
        nickName: [
          { required: true, message: '请输入昵称', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'blur' }
        ]
      }
    }
  },
  created () {
    this.handleForm = JSON.parse(JSON.stringify(this.userInfo))
    this.oldPhone = this.handleForm.phone
  },
  methods: {
    editPhone () {
      this.isEditPhone = true
      this.getSmsCode()
    },
    getSmsCode () {
      this.isCheckMsgCode = true
      this.$refs.handleForm.validateField('phone', value => {
        if (!value) {
          this.handleCountDown()
          const params = {
            phoneNo: this.handleForm.phone,
            type: 1
          }
          this.api.commonService.sendCheckSmsCode(params).then(res => {
            if (res.code === '644') {
              this.$message.error('获取验证码太频繁，请稍后重试')
            } else if (res.errorMessage) {
              this.$message.error('获取验证码失败，请稍后重试')
            } else {
              this.handleForm.smsId = res.body.smsId
            }
          })
        }
      })
    },
    checkSmsCode (value) {
      if (value.length >= 6) {
        const params = {
          phone: this.handleForm.phone,
          smsId: this.handleForm.smsId,
          smsCode: this.handleForm.smsCode,
          smsType: 1
        }
        this.api.commonService.validateSmsCode(params).then(res => {
          if (res.errorMessage) {
            this.$message.error(res.errorMessage)
          } else {
            this.isCheckMsgCode = false
            this.handleForm.smsCode = ''
            this.handleForm.phone = ''
          }
        })
      }
    },
    handleCountDown () {
      this.countDown.startCount = true
      this.countDown.timer = setInterval(() => {
        if (this.countDown.count === 0) {
          clearInterval(this.countDown.timer)
          this.countDown.startCount = false
          this.countDown.count = this.countDown.defaultCount
        } else {
          this.countDown.count--
        }
      }, 1000)
    },
    updateUserInfo () {
      this.$refs.handleForm.validate((valid) => {
        console.log(valid)
        if (valid) {
          this.logining = true
          let params = {
            ...this.handleForm
          }
          this.api.commonService.updateCompanyStaffInfo(params).then(res => {
            if (res.errorMessage) {
              this.$message.error(res.errorMessage)
            } else {
              this.myVisible = false
              this.$store.dispatch('fetchUserInfo')
            }
            this.logining = false
          })
        }
      })
    },
    handleClose () {
      this.myVisible = false
    },
    handleAvatarSuccess (data) {
      this.handleForm.headPortaitUrl = data.url
    }
  }
}
</script>
<style lang="less" scope>
.user-box {
  .el-dialog__body {
    padding-left: 60px;
    padding-right: 60px;
    .el-input__inner {
      border-radius: 2px;
    }
  }
  .phone{
    display: flex;
    span{
      padding-right: 8px;
    }
  }
  .tips {
    color: #999;
    line-height: initial;
  }
  .msg-code {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .msg-btn {
      width: 102px;
      padding: 0 10px;
      border-radius: 2px;
      margin-left: 15px;
      &.sended {
        color: #cccccc;
        background-color: #f5f5f5;
        border: 1px solid #d9d9d9;
      }
    }
  }
}
.force {
  .el-dialog__header {
    text-align: center;
    .el-dialog__title {
      font-size: 24px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/area-base/components/common/editUserInfo.vue